import { Box } from '@mui/material'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import QuoteEntry from './QuoteEntry'
import QuotesTitle from './QuotesTitleOld'

type QuotesProps = {
  type: string
  quotes: any
  bookingVehicleId: string
  quoteReference: string
  setIsReallocateModalOpen: (x: boolean) => void
  previousPrice?: number
}

const Quotes = ({
  type,
  quotes,
  bookingVehicleId,
  quoteReference,
  setIsReallocateModalOpen,
  previousPrice,
}: QuotesProps) => {
  return (
    <Box component="div" sx={{ width: '100%', marginBottom: '30px' }}>
      <QuotesTitle
        title={VehicleDisplayName({ vehicleDetails: quotes[0].vehicleDetails })}
        example={quotes[0].vehicleDetails.example}
        image={quotes[0].vehicleDetails.icon}
      />
      {quotes?.map((quote: any, index: number) => (
        <QuoteEntry
          key={`${type}-quote-${index}`}
          supplierName={
            quote.supplierAlias ? quote.supplierAlias : quote.supplierName
          }
          contactNumber={quote.supplierContactNumber}
          price={quote.price}
          eta={quote.eta}
          bookingVehicleId={bookingVehicleId}
          supplierQuoteReference={quote.supplierQuoteReference}
          quoteReference={quoteReference}
          isDestinationSupplier={quote.isDestinationLogicQuote}
          setIsReallocateModalOpen={setIsReallocateModalOpen}
          vehicleTypeName={
            quote.vehicleDetails?.vehicleTypeName ?? quote.vehicleTypeName
          }
          isPreferredSupplier={quote.isPreferredSupplier}
          currency={quote.estimatedPriceCurrency}
          previousPrice={previousPrice}
        />
      ))}
    </Box>
  )
}

export default Quotes
